/**
 * GA4 event helper. Safe no-op when gtag isn't loaded
 * (e.g. admin pages, or when no GA4 ID is configured).
 *
 * Recommended event names follow GA4 standard schema where possible:
 *   - add_to_cart, view_item, purchase, view_item_list  (e-commerce standard)
 *   - generate_lead, contact, phone_click, whatsapp_click  (lead conversion)
 *   - booking_submitted  (custom — RO Dekho specific)
 */
export const trackEvent = (eventName, params = {}) => {
  try {
    if (typeof window === 'undefined') return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, params);
  } catch {
    // swallow — analytics must never break user flows
  }
};

export const trackBooking = ({ source, city, area, service_type, value = 0 }) => {
  trackEvent('booking_submitted', {
    source,
    city,
    area,
    service_type,
    value,
    currency: 'INR',
  });
  // Standard GA4 lead event for conversion tracking
  trackEvent('generate_lead', { source, value, currency: 'INR' });
};

export const trackPhoneClick = (phone, source = 'unknown') =>
  trackEvent('phone_click', { phone, source });

export const trackWhatsAppClick = (phone, source = 'unknown') =>
  trackEvent('whatsapp_click', { phone, source });

export const trackAddToCart = (item) => {
  trackEvent('add_to_cart', {
    currency: 'INR',
    value: Number(item?.price || item?.salePrice || 0),
    items: [{
      item_id: String(item?.id || item?._id || ''),
      item_name: item?.name || '',
      item_brand: item?.brand || '',
      item_category: item?.category || item?.category_name || '',
      price: Number(item?.price || item?.salePrice || 0),
      quantity: Number(item?.quantity || 1),
    }],
  });
};

export const trackPurchase = ({ orderId, total, items = [] }) => {
  trackEvent('purchase', {
    transaction_id: String(orderId || ''),
    value: Number(total || 0),
    currency: 'INR',
    items: items.map(it => ({
      item_id: String(it?.id || it?._id || ''),
      item_name: it?.name || '',
      item_brand: it?.brand || '',
      price: Number(it?.price || it?.salePrice || 0),
      quantity: Number(it?.quantity || 1),
    })),
  });
};

export const trackViewItem = (item) => {
  trackEvent('view_item', {
    currency: 'INR',
    value: Number(item?.price || item?.salePrice || 0),
    items: [{
      item_id: String(item?.id || item?._id || ''),
      item_name: item?.name || '',
      item_brand: item?.brand || '',
      item_category: item?.category || item?.category_name || '',
      price: Number(item?.price || item?.salePrice || 0),
    }],
  });
};
